const DisplayFieldErrors = ({
  displayText,
  className = 'text-danger'
}: {
  displayText: string;
  className?: string;
}) => <span className={`fs-sm ${className}`}>{displayText}</span>;

export default DisplayFieldErrors;
